import React from 'react';
import { Search, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/common';
import { JobTable } from '@/components/jobs/JobTable';

interface RecruiterPostingsTabProps {
  myJobsCount: number;
  postingSearchQuery: string;
  setPostingSearchQuery: (query: string) => void;
  setActiveTab: (tab: any) => void;
  loadingJobs: boolean;
  filteredJobs: any[];
  handleDeleteJob: (id: string) => void;
}

/**
 * Tab Quản Lý Tin Đăng (`postings`)
 * Quản lý danh sách các bài đăng tuyển dụng, tìm kiếm tin đăng và điều hướng tạo tin mới.
 */
export const RecruiterPostingsTab: React.FC<RecruiterPostingsTabProps> = ({
  myJobsCount,
  postingSearchQuery,
  setPostingSearchQuery,
  setActiveTab,
  loadingJobs,
  filteredJobs,
  handleDeleteJob,
}) => {
  return (
    <div className="space-y-6 animate-fade-in text-left">
      {/* Thanh Tiêu Đề, Ô Tìm Kiếm Tin Đăng & Nút Đăng Tin Mới */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b pb-5">
        <div>
          <h1 className="font-display font-bold text-2xl text-gray-900 leading-tight">Quản lý tin đăng</h1>

        </div>
        <div className="flex items-center gap-3">
          <div className="relative w-64">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={15} />
            <input
              type="text"
              placeholder="Tìm kiếm tin đăng..."
              value={postingSearchQuery}
              onChange={(e) => setPostingSearchQuery(e.target.value)}
              className="w-full h-10 pl-9 pr-4 bg-white border border-gray-200 rounded-xl text-xs font-semibold focus:border-orange-400 outline-none transition-all shadow-sm"
            />
          </div>
          <Button
            onClick={() => setActiveTab('post_job')}
            className="bg-[#f97316] hover:bg-[#e04700] text-white  text-sm h-10 px-5 rounded-xl flex items-center gap-1.5 shadow-md shadow-orange-100 transition-all hover:scale-102"
          >
            <Plus size={16} /> Đăng tin mới
          </Button>
        </div>
      </div>

      {/* Hiển Thị Trạng Thái Đang Tải / Trạng Thái Trống / Bảng Dữ Liệu Tin Đăng */}
      {loadingJobs ? (
        <div className="py-20 flex justify-center">
          <Spinner size="md" />
        </div>
      ) : filteredJobs.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-3xl border border-gray-100 p-8 shadow-sm">
          <h3 className="font-bold text-lg text-gray-800 mb-2">Chưa có tin tuyển dụng nào</h3>
          <p className="text-xs text-gray-400 mb-6">Bạn chưa tạo tin đăng tuyển dụng nào hoặc từ khóa tìm kiếm không khớp.</p>
          <Button
            onClick={() => setActiveTab('post_job')}
            className="bg-[#f97316] hover:bg-[#e04700] text-white rounded-xl px-6 font-bold shadow-md h-10"
          >
            Đăng tin đầu tiên
          </Button>
        </div>
      ) : (
        <JobTable jobs={filteredJobs} onDelete={handleDeleteJob} />
      )}
    </div>
  );
};

export default RecruiterPostingsTab;
